(function() {
  function initKdcHeader(sectionId) {

    
    var root = document.getElementById("KdcMenu-" + sectionId);
    var triggerDesktop = document.getElementById("KdcMenuButton-" + sectionId);
    var triggerMobile = document.getElementById("KdcMenuButtonMobile-" + sectionId);
    var drawer = document.getElementById("KdcDrawer-" + sectionId);
    var overlay = document.getElementById("KdcOverlay-" + sectionId);
    var panel = document.getElementById("KdcDrawerPanel-" + sectionId);
    var headerShell = document.getElementById("KdcHeaderShell-" + sectionId);

    if (!root || !drawer || !panel || !headerShell) return;
    if (root.dataset.kdcBound === "true") return;
    root.dataset.kdcBound = "true";

    var triggers = [triggerDesktop, triggerMobile].filter(Boolean);
    if (!triggers.length) return;

    var headerBar = headerShell.querySelector(".kdc-header-bar");
    var spacer = headerShell.nextElementSibling && headerShell.nextElementSibling.classList.contains('kdc-header-spacer')
      ? headerShell.nextElementSibling
      : null;

    var submenus = root.querySelectorAll(".kdc-drawer__submenu");
    var links = root.querySelectorAll(".kdc-drawer a");

    var stickyType = headerShell.getAttribute("data-sticky-type") || "none";
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var headerHeight = 80;

    function isMobile() {
      return window.matchMedia("(max-width: 989px)").matches;
    }

    function setHeaderHeight() {
      headerHeight = headerBar ? (headerBar.offsetHeight || 80) : 80;
      document.documentElement.style.setProperty("--kdc-header-height", headerHeight + "px");
      document.documentElement.style.setProperty("--header-height", headerHeight + "px");

      if (spacer) {
        if (isMobile()) {
          spacer.style.display = "none";
          spacer.style.height = "0px";
        } else {
          spacer.style.height = headerHeight + "px";
        }
      }
    }

    function isOpen() {
      return root.classList.contains("is-open");
    }

    function enableStickyMode() {
      if (stickyType === "none") {
        if (isMobile()) {
          headerShell.classList.add("is-sticky-enabled");
          headerShell.classList.remove("is-hidden");
          if (spacer) spacer.style.display = "none";
          return;
        }

        headerShell.classList.remove("is-sticky-enabled", "is-hidden");
        if (spacer) spacer.style.display = "none";
        return;
      }

      headerShell.classList.add("is-sticky-enabled");
      if (spacer) spacer.style.display = isMobile() ? "none" : "block";
    }

    function showHeader() {
      headerShell.classList.remove("is-hidden");
    }

    function hideHeader() {
      if (isOpen()) {
        showHeader();
        return;
      }

      if (isMobile() && (window.pageYOffset || document.documentElement.scrollTop || 0) <= 8) {
        showHeader();
        return;
      }

      headerShell.classList.add("is-hidden");
    }

    function syncState() {
      var open = isOpen();

      triggers.forEach(function(trigger) {
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
        var labelOpen = trigger.getAttribute("data-label-open") || "Ouvrir le menu";
        var labelClose = trigger.getAttribute("data-label-close") || "Fermer le menu";
        trigger.setAttribute("aria-label", open ? labelClose : labelOpen);
      });

      drawer.setAttribute("aria-hidden", open ? "false" : "true");

      if (open) {
        document.documentElement.classList.add("kdc-menu-open");
        document.body.classList.add("kdc-menu-open");
        showHeader();
      } else {
        document.documentElement.classList.remove("kdc-menu-open");
        document.body.classList.remove("kdc-menu-open");
      }
    }

    function openMenu() {
      root.classList.add("is-open");
      syncState();
    }

    function closeMenu(returnFocus) {
      root.classList.remove("is-open");

      submenus.forEach(function(item) {
        item.removeAttribute("open");
      });

      syncState();

      if (returnFocus !== false && triggers[0]) {
        triggers[0].focus({ preventScroll: true });
      }
    }

    function toggleMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (isOpen()) closeMenu();
      else openMenu();
    }

    function updateSticky() {
      ticking = false;

      if (isOpen()) {
        showHeader();
        return;
      }

      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var delta = currentY - lastY;

      if (isMobile()) {
        if (currentY <= 8) {
          showHeader();
          lastY = currentY;
          return;
        }

        if (delta > 4 && currentY > headerHeight) {
          hideHeader();
        } else if (delta < -4) {
          showHeader();
        }

        lastY = currentY;
        return;
      }

      if (stickyType === "none") {
        showHeader();
        return;
      }

      if (stickyType === "always" || stickyType === "reduce-logo-size") {
        showHeader();
        return;
      }

      if (document.documentElement.classList.contains("kdc-menu-open")) {
        showHeader();
        return;
      }

      if (currentY <= 8) {
        showHeader();
        lastY = currentY;
        return;
      }

      if (delta > 4 && currentY > headerHeight) {
        hideHeader();
      } else if (delta < -4) {
        showHeader();
      }

      lastY = currentY;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSticky);
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener("click", toggleMenu);
    });

    if (overlay) {
      overlay.addEventListener("click", function() {
        closeMenu();
      });
    }

    links.forEach(function(link) {
      link.addEventListener("click", function() {
        closeMenu(false);
      });
    });

    submenus.forEach(function(item) {
      item.addEventListener("toggle", function() {
        if (!item.hasAttribute("open")) return;
        submenus.forEach(function(other) {
          if (other !== item) other.removeAttribute("open");
        });
      });
    });

    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape") closeMenu();
    });

    enableStickyMode();
    setHeaderHeight();
    syncState();
    showHeader();

    window.addEventListener("resize", function() {
      enableStickyMode();
      setHeaderHeight();
      updateSticky();
    }, { passive: true });

    window.addEventListener("scroll", onScroll, { passive: true });

    if ("ResizeObserver" in window && headerBar) {
      var ro = new ResizeObserver(function() {
        setHeaderHeight();
      });
      ro.observe(headerBar);
    }

    document.addEventListener("shopify:section:load", function(event) {
      if (!event || !event.target || !event.target.querySelector) return;
      if (!event.target.querySelector("#KdcMenu-" + sectionId)) return;

      stickyType = headerShell.getAttribute("data-sticky-type") || "none";
      enableStickyMode();
      setHeaderHeight();
      closeMenu(false);
      showHeader();
      lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
      updateSticky();
    });
  
  }
  function kdcHeaderBoot() {
    document.querySelectorAll('[id^="KdcMenu-"]').forEach(function (el) {
      initKdcHeader(el.id.slice("KdcMenu-".length));
    });
  }
  kdcHeaderBoot();
  document.addEventListener('shopify:section:load', kdcHeaderBoot);
})();
